import axios from 'axios'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/consumer-bookings-api`

export type OfflineBookingDecision =
  | 'accept'
  | 'decline'
  | 'cancel'
  | 'complete'

export type OfflineBookingCompletionStatus = 'Completed' | 'No_Show'
export type OfflineBookingAdditionalChargeTypeName =
  | 'Parking'
  | 'Toll'
  | 'Tip'
  | 'Other'

export interface OfflineBookingPricePayload {
  price: number
  currency: string
  vat: number
}

export interface OfflineBookingExtraPayload {
  additionalChargeTypeName: OfflineBookingAdditionalChargeTypeName
  price: OfflineBookingPricePayload
}

export interface OfflineBookingCompletePayload {
  correlationId: string
  data: {
    communicationReference: string
    status: OfflineBookingCompletionStatus
    driverPrice: OfflineBookingPricePayload
    waitingPrice?: OfflineBookingPricePayload
    serviceCharge?: OfflineBookingPricePayload
    unknownExtras?: OfflineBookingExtraPayload[]
    journeyDistance?: number
    journeyTime?: number
    co2Emmissions?: number
  }
}

async function getBookingTracking(communicationReference: any) {
  const response = await axios({
    method: 'POST',
    url: BASE_URL.concat(`/bookings/tracking`),
    headers: {
      'Jyrney-API-Key': `${process.env.REACT_APP_CONSUMERBOOKING_API_KEY}`,
    },
    data: {
      data: {
        communicationReference: decodeURIComponent(communicationReference),
      },
    },
  })
  return response
}

async function updateFlexibleBooking(
  communicationReference: any,
  status: 'ready' | 'cancel',
) {
  const response = await axios({
    method: 'POST',
    url: BASE_URL.concat(`/bookings/flexible/${status}`),
    headers: {
      'Jyrney-API-Key': `${process.env.REACT_APP_CONSUMERBOOKING_API_KEY}`,
    },
    data: {
      data: {
        communicationReference: decodeURIComponent(communicationReference),
      },
    },
  })
  return response
}

async function updateOfflineBooking(
  communicationReference: any,
  decision: OfflineBookingDecision,
  payload?: OfflineBookingCompletePayload,
) {
  const decodedCommunicationReference = decodeURIComponent(
    communicationReference,
  )
  const requestData = payload
    ? {
        ...payload,
        data: {
          ...payload.data,
          communicationReference: decodedCommunicationReference,
        },
      }
    : {
        correlationId: crypto.randomUUID(),
        data: {
          communicationReference: decodedCommunicationReference,
        },
      }

  const response = await axios({
    method: 'POST',
    url: BASE_URL.concat(`/bookings/offline/${decision}`),
    headers: {
      'Jyrney-API-Key': `${process.env.REACT_APP_CONSUMERBOOKING_API_KEY}`,
    },
    data: requestData,
  })
  return response
}

async function getFlexibleBooking(communicationReference: any) {
  const response = await axios({
    method: 'POST',
    url: BASE_URL.concat(`/bookings/flexible/retrieve`),
    headers: {
      'Jyrney-API-Key': `${process.env.REACT_APP_CONSUMERBOOKING_API_KEY}`,
    },
    data: {
      data: {
        communicationReference: decodeURIComponent(communicationReference),
      },
    },
  })
  return response
}

export const consumerAPI = {
  getBookingTracking,
  updateFlexibleBooking,
  getFlexibleBooking,
  updateOfflineBooking,
}
